module.exports = __webpack_public_path__ + "static/solomon-motors-city-845322c5670ba6dbbd69722024f2f69a.jpg";